module.exports = __webpack_public_path__ + "img/banner2.e4488c60.jpg";